import * as React from "react";

function SvgIcons8Mandatory(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M25 4v9h2V4zM13 9c-3.3 0-6 2.7-6 6 0 1.945.934 3.684 2.375 4.781C6.215 21.18 4 24.332 4 28h2c0-3.879 3.121-7 7-7s7 3.121 7 7h2c0-3.668-2.215-6.82-5.375-8.219A6.007 6.007 0 0019 15c0-3.3-2.7-6-6-6zm0 2c2.223 0 4 1.777 4 4s-1.777 4-4 4-4-1.777-4-4 1.777-4 4-4zm12 4v2h2v-2z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Mandatory);
